import styled from 'styled-components'
import { fontType, mediaQuery, toRem } from '../../styles/functions'

export const Container = styled.footer`
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: ${({ theme }) => theme.COLORS.BLACK};
	padding: 0 75px;
	color: ${({ theme }) => theme.COLORS.WHITE};

	${mediaQuery('md')(`
			padding: 0 16px;
		`)}
`

export const HelpContainer = styled.div`
	display: flex;
	width: 100%;
	display: flex;
	padding: 80px 50px 110px 50px;
	justify-content: space-between;
	align-items: center;

	${mediaQuery('md')(`
		flex-direction: column;
        align-items: center;
		padding: 80px 0 80px 0;
        
        *{
            text-align: center;
            align-items: center;
        }
	`)}
`

export const HelpSection = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`

export const HelpTitle = styled.p`
	${fontType(2)}
	text-align: left;
	font-size: ${toRem(48)};
	letter-spacing: -0.51px;
	max-width: 400px;
  	margin-bottom: 30px;
	text-decoration: underline;

	${mediaQuery('md')(`
		text-align: center;
		margin-bottom: 50px;
	`)}
`

export const HelpSimpleText = styled.span`
	${fontType(1)}
	font-size: ${toRem(24)};
	text-align: left;

	${mediaQuery('md')(`
		text-align: center;
	`)}
`

export const NeedHelpText = styled.span`
	${fontType(1)}
	font-size: ${toRem(32)};
	text-align: left;
	margin-bottom: 38px;

	${mediaQuery('md')(`
		text-align: center;
	`)}
`

export const PhonesWrapper = styled.div`
	margin-bottom: 32px;
`

export const HelpStrongText = styled.p`
	//${fontType(1)}
	font-size: ${toRem(24)};
	font-weight: 300;
	text-align: left;
	margin-bottom: 8px;

	${mediaQuery('md')(`
		text-align: center;
		
	`)}
`

export const FooterText = styled.p`
	${fontType(2)}
	font-size: ${toRem(24)};
	text-align: left;

	${mediaQuery('md')(`
		text-align: center;
		
	`)}
`

export const HelpParagraph01 = styled.p`
	${fontType(1)};
	font-size: ${toRem(24)};
	line-height: 24px;
	margin-bottom: 32px;

	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}
`
export const HelpParagraph02 = styled.p`
	${fontType(1)};
	font-size: ${toRem(24)};
	line-height: 24px;

	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}
`

export const Hr = styled.hr`
	border: 1px solid #FFF;
`

export const Link = styled.a`
	color: ${({ theme }) => theme.COLORS.ANTAGONISTA_COLOR};
	display: inline-block;
	margin-right: 4px;
	margin-left: 4px;

	&:last-child {
		margin-right: 0px;
	}
`
export const InfosContainer = styled.div`
	width: 100%;
	display: flex;
	padding: 80px 40px;
	gap: 16px;

	${mediaQuery('md')(`
		flex-direction: column;
        align-items: center;
		padding: 80px 20px;
        
        *{
            text-align: center;
            align-items: center;
        }
	`)}
`

export const InfosSection = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	margin-bottom: 24px;
	${mediaQuery('xs')(`
		border-right: 0 !important;
		padding: 0 !important;
	`)}
`

export const Utils = styled.a`
	${fontType(1)}
	font-size: ${toRem(28)};
	cursor: pointer;
	margin-bottom: 32px;
	//text-decoration: none;
	color: ${({ theme }) => theme.COLORS.WHITE};
`

export const InfosTitle = styled.label`
	${fontType(2)}
	text-align: left;
	font-size: ${toRem(28)};
	letter-spacing: 0px;
	margin-bottom: 32px;
`

export const PaymentsContainer = styled.div`
	width: fit-content;
	gap: 8px;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
`

export const PaymentMethod = styled.img`
	width: 58px;
	height: 40px;
`

export const SecurityContainer = styled.div`
	display: flex;
	margin-bottom: 48px;
	/* gap: 22px; */

	${mediaQuery('md')(`
		flex-direction: column;
        align-items: center;
		`)}
`

export const SecurityItem = styled.img`
margin-right: 16px;
`

export const CopyrightContainer = styled.div`
	width: 100%;
	padding: 32px 40px;
	align-items: center;
	display: flex;
	justify-content: space-between;
	gap: 16px;

	/* * {
		margin: 0;
	} */

	${mediaQuery('md')(`
		flex-direction: column;
        align-items: center;
        text-align: center;
		padding: 32px 20px;
        
       
		`)}
`
